var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row",
      class: _vm.$q.screen.gt.sm ? "full-row-exactly-with-back-button" : ""
    },
    [
      _vm.matchAnAgentModal.visible
        ? _c("bj-match-agent-modal", {
            attrs: {
              "match-an-agent": _vm.matchAnAgentModal,
              "include-unverified": false
            }
          })
        : _vm._e(),
      _vm.unmatchAnAgentModal.visible
        ? _c("bj-unmatch-agent-modal", {
            attrs: { "unmatch-an-agent": _vm.unmatchAnAgentModal }
          })
        : _vm._e(),
      _vm.changeAnAgentModal.visible
        ? _c("bj-change-agent-modal", {
            attrs: {
              "change-an-agent": _vm.changeAnAgentModal,
              "include-unverified": false
            },
            on: { "agent-changed": _vm.agentChanged }
          })
        : _vm._e(),
      _vm.takeOverAssignModal.visible
        ? _c("bj-take-over-assign-modal", {
            attrs: { "take-over-assign": _vm.takeOverAssignModal }
          })
        : _vm._e(),
      _vm.createInquiryScheduleModal.visible
        ? _c("bj-create-inquiry-schedule-modal", {
            attrs: {
              "create-inquiry-schedule-modal": _vm.createInquiryScheduleModal
            }
          })
        : _vm._e(),
      _vm.changeInquiryTimeModal.visible
        ? _c("bj-change-inquiry-time-modal", {
            attrs: { "change-inquiry-time-modal": _vm.changeInquiryTimeModal }
          })
        : _vm._e(),
      _c("sd-timeline", {
        ref: "timeline",
        attrs: {
          id: _vm.$route.params.id,
          "class-name": "inquiries",
          "timeline-title": "Inquiry Timeline",
          actions: _vm.actions
        },
        on: { loaded: _vm.loaded },
        scopedSlots: _vm._u([
          {
            key: "before-timeline",
            fn: function(ref) {
              var inquiry = ref.model
              return _c(
                "div",
                { staticClass: "col-md-4 col-xs-12" },
                [
                  _c(
                    "q-card",
                    { attrs: { id: "inquiry-details" } },
                    [
                      _c("q-card-title", [
                        _vm._v("\n          Inquiry Details\n        ")
                      ]),
                      _c(
                        "q-list",
                        { attrs: { separator: "" } },
                        [
                          _c(
                            "q-item",
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      "\n                Created at\n              "
                                    )
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      _c("SdDatetime", {
                                        attrs: {
                                          value: inquiry.created_at,
                                          "market-id":
                                            inquiry.property &&
                                            inquiry.property.market_id,
                                          timezone:
                                            inquiry.property &&
                                            inquiry.property.timezone
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      "\n                Updated at\n              "
                                    )
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      _c("SdDatetime", {
                                        attrs: {
                                          value: inquiry.updated_at,
                                          "market-id":
                                            inquiry.property &&
                                            inquiry.property.market_id,
                                          timezone:
                                            inquiry.property &&
                                            inquiry.property.timezone
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      "\n                Source\n              "
                                    )
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      _c("q-chip", [
                                        _vm._v(_vm._s(inquiry.source.name))
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      "\n                Status\n              "
                                    )
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      _c(
                                        "q-chip",
                                        {
                                          attrs: {
                                            color:
                                              inquiry.status ===
                                              _vm.$config.inquiryStatuses
                                                .MATCHING_FAILED
                                                ? "negative"
                                                : ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                inquiry.status.toUpperCase()
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      inquiry.uninterested_at
                                        ? _c("q-icon", {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy"
                                              }
                                            ],
                                            attrs: {
                                              color: "negative",
                                              name: "cancel",
                                              title: "Marked as uninterested"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      "\n                Lead\n              "
                                    )
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      _c("SdLeadFullName", {
                                        attrs: { lead: inquiry.lead }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(
                                      "\n                Agent\n              "
                                    )
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "" } },
                                    [
                                      inquiry.tour && inquiry.tour.user
                                        ? _c(
                                            "span",
                                            [
                                              inquiry.tour.user.role === "agent"
                                                ? [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name: "app.agents",
                                                            params: {
                                                              id:
                                                                inquiry.tour
                                                                  .user.id
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              inquiry.tour.user
                                                                .full_name
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "app.businesses.profile.user",
                                                            params: {
                                                              id:
                                                                inquiry.tour
                                                                  .user
                                                                  .business_id,
                                                              userId:
                                                                inquiry.tour
                                                                  .user.id
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              inquiry.tour.user
                                                                .full_name
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              "\n                  Unassigned\n                "
                                            )
                                          ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          inquiry.tour
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Tour Status\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          inquiry.tour.is_taken_over
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                  Taken Over -\n                "
                                                )
                                              ])
                                            : inquiry.tour.is_self_showing
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                  Self Showing -\n                "
                                                )
                                              ])
                                            : _vm._e(),
                                          inquiry.tour
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getHumanScheduleStatus(
                                                        inquiry.tour.status
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ])
                                            : _vm._e(),
                                          inquiry.tour &&
                                          inquiry.tour.device_code
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                    Used device code: " +
                                                        _vm._s(
                                                          inquiry.tour
                                                            .device_code
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !inquiry.property
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Interested in property\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                inquiry.interested_in_property
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          inquiry.property
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Property name\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name:
                                                    "app.properties.combined",
                                                  params: {
                                                    id: inquiry.property.id
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    inquiry.property
                                                      .short_address
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          inquiry.unit && inquiry.unit.name
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Unit name\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(inquiry.unit.name) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          inquiry.tour
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Tour\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              rounded: "",
                                              outline: "",
                                              size: "sm",
                                              color: "primary",
                                              label: inquiry.tour.id
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.redirect("app.tours", {
                                                  id: inquiry.tour.id
                                                })
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          inquiry.is_video ||
                          _vm.get(inquiry, "schedule_inquiry.schedule.is_video")
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm.get(
                                            inquiry,
                                            "schedule_inquiry.schedule.is_video"
                                          )
                                            ? _c(
                                                _vm.get(
                                                  inquiry,
                                                  "schedule_inquiry.schedule.meeting_room.deleted_at"
                                                )
                                                  ? "span"
                                                  : "a",
                                                {
                                                  tag: "component",
                                                  attrs: {
                                                    href:
                                                      "https://" +
                                                      _vm.get(
                                                        inquiry,
                                                        "schedule_inquiry.schedule.meeting_room.url"
                                                      ),
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Live Video Tour\n                  "
                                                  ),
                                                  _c(
                                                    "q-chip",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "5px",
                                                        padding:
                                                          "0.25rem 0.5rem"
                                                      },
                                                      attrs: {
                                                        dense: "",
                                                        color: "blue",
                                                        "text-color": "black"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "q-icon fa fa-video"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm.get(
                                inquiry,
                                "schedule_inquiry.schedule.is_open_house"
                              )
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Open House\n                "
                                          ),
                                          _c(
                                            "q-chip",
                                            {
                                              staticStyle: {
                                                "margin-left": "5px",
                                                padding: "0.25rem 0.5rem"
                                              },
                                              attrs: {
                                                dense: "",
                                                color: "blue",
                                                "text-color": "black"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "q-icon fa fa-users"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          inquiry.schedule_inquiry
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            "\n                Tour at\n              "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "" } },
                                        [
                                          _c("SdDatetime", {
                                            attrs: {
                                              value:
                                                inquiry.schedule_inquiry
                                                  .schedule.tour_at,
                                              "market-id":
                                                inquiry.property.market_id,
                                              timezone:
                                                inquiry.property.timezone
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          inquiry.persona_identification_url
                            ? _c(
                                "q-item",
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  inquiry.persona_identification_url,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Persona Inquiry\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("p"),
                  _c(
                    "q-card",
                    { attrs: { id: "lead-identity-history" } },
                    [
                      _c("q-card-title", [
                        _vm._v(
                          "Inquiry - Lead Identity History: (" +
                            _vm._s(_vm.leadIdentityHistory.length) +
                            ")"
                        )
                      ]),
                      _c("q-card-separator"),
                      _c("q-card-main", { staticClass: "helper-text" }, [
                        _c("p", [
                          _vm._v(
                            "Displays only the relevant identity records related to the current inquiry."
                          )
                        ]),
                        _c(
                          "p",
                          [
                            _vm._v(
                              "\n            To view all identity history records, visit\n            "
                            ),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "app.leads.profile",
                                    params: { id: inquiry.lead.id }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(inquiry.lead.full_name) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" lead profile page.\n          ")
                          ],
                          1
                        )
                      ]),
                      _c("q-card-separator"),
                      _vm.leadIdentityHistory.length
                        ? _c(
                            "q-card-main",
                            {
                              staticClass:
                                "relative-position scrollable-wrapper"
                            },
                            [
                              _c("SdLeadIdentityHistoryTimeline", {
                                attrs: {
                                  "identity-history": _vm.leadIdentityHistory
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }